// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".permision-tips[data-v-3ddccefb]{width:100%;height:100%;position:relative}.pt-icon[data-v-3ddccefb]{margin-bottom:20px;display:block}.pt-content[data-v-3ddccefb]{position:absolute;top:30%;left:50%;margin-left:-300px;width:600px;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
